// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"5":"dc8ff27f","29":"b2dadb8f","39":"2f88e611","216":"18d4bea1","265":"3dbe4c98","340":"7c5c33d0","473":"35ea1a40","491":"94d6b2d9","500":"e364f39e","562":"d75b0114","618":"66167365","687":"60ff42ef","808":"5fbd5f05","878":"19492fd5","993":"4572c8fe"}[chunkId] + ".js";
};